import { Badge } from '@mantine/core';
import { Encounter } from '@medplum/fhirtypes';
import { EncounterStatus } from '@bariendo/lib/constants';

type EncounterStatusBadgeProps = {
  status: Encounter['status'] | 'editing';
};

export function EncounterStatusBadge({ status }: EncounterStatusBadgeProps) {
  if (!status) return null;

  let color: string;
  let label: string;

  // TODO: BAR-1432 will define the Sign and Lock feature, it will introduce some more label to the Badge like "Signed Only"
  // Also, some more logics will be needed to determine the color of the Badge
  switch (status) {
    case EncounterStatus.FINISHED:
      color = 'green';
      label = 'Completed';
      break;
    case EncounterStatus.IN_PROGRESS:
      color = 'yellow';
      label = 'Draft';
      break;
    case EncounterStatus.PLANNED:
      color = 'yellow';
      label = 'Draft';
      break;
    case EncounterStatus.EDITING:
      color = 'yellow';
      label = 'Editing';
      break;
    default:
      color = 'gray';
      label = status;
      break;
  }

  return (
    <Badge size="sm" color={color} variant="light">
      {label}
    </Badge>
  );
}
